import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import WhiteArrow from "images/white-arrow.svg";

import "./Button.css";
const Button = ({ btnText, pagePath, btnStyle, btnArrowFlag }) => {
    return (
        <Link to={pagePath} className="btn-container">
            <span className={classNames("btn-container__btn", btnStyle)}>
                <span>{btnText}</span>
                {btnArrowFlag ? (
                    <span className="arrow">
                        <img src={WhiteArrow} />
                    </span>
                ) : null}
            </span>
        </Link>
    );
};

export default Button;

Button.defaultProps = {
    pagePath: "/",
    btnStyle: "",
    btnArrowFlag: true,
};
